<template>
  <svg
    :id="'line-' + rect.id"
    :width="largeX"
    :hight="largeY"
    :viewBox="viewBox"
    class="line-graph pega-comment-line"
    data-test="comment-line-svg"
  >
    <path
      :d="pointString"
      data-test="comment-line-path"
    />
  </svg>
</template>

<script>
export default {
  props: {
    rect: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      my: { // 基点記録用
        x: 0,
        y: 0
      },
      viewBox: '0 0 0 0'
    }
  },
  computed: {
    largeX () { // より大きい方のx座標を返す
      return this.x1 > this.x2 ? this.x1 : this.x2
    },
    largeY () { // より大きい方のy座標を返す
      return this.y1 > this.y2 ? this.y1 : this.y2
    },
    x1 () { // 始点x座標（ハイライト右上の座標-基点座標）
      return this.rect.x1 - this.my.x
    },
    y1 () { // 始点y座標（ハイライト右上の座標-基点座標）
      return this.rect.y1 - this.my.y
    },
    x2 () { // 終点x座標（コメント左上の座標-基点座標）
      return this.rect.x2 - this.my.x
    },
    y2 () { // 終点y座標（コメント左上の座標-基点座標）
      return this.rect.y2 - this.my.y
    },
    pointString () {
      // svgによる折れ線の描画プロット。「始点」「頂点座標」「終点」の3点を渡すとsvgが線で繋いでくれる。
      // 斜線部分の横幅を変えたい場合は「頂点座標」のx座標から引いている値を修正する。
      // ※イメージ
      // [ハイライト]￣＼
      //               [コメント]
      // propsで渡ってくる値は「画面全体に対する座標」になる。
      // 線の描画基点はsvg描画エリアの左上の座標となるため、基点が「(x,y) = (0,0)」になるように計算する

      const vertexMergin = 50 // 頂点座標に利用するマージン

      return 'M' + this.x1 + ',' + this.y1 + ' ' + // 始点（ハイライトの右上頂点のxy座標から基点を引いたもの）
      'L' + (this.x2 - vertexMergin) + ',' + this.y1 + ' ' + // 頂点座標（コメントのx座標-マージン（斜線部の幅）,ハイライトのy座標(それぞれ基点を引いたもの)）
      'L' + this.x2 + ',' + this.y2 // 終点（コメント左上のxy座標から基点を引いたもの）
    }
  },
  mounted () { // 描画完了後の処理
    const lineRect = document.getElementById('line-' + this.rect.id).getBoundingClientRect()
    // 基点を記録（線の描画時の座標算出に利用）
    this.my.x = lineRect.left
    this.my.y = lineRect.top
    // viewBox(描画エリア)を線の描画に必要なサイズに下端を抑える
    this.viewBox = '0 0 ' + this.largeX + ' ' + this.largeY
  }
}
</script>
